import { colors as grouponColors } from "../../groupon/foundation"

export const colors = {
  ...grouponColors,
  purple600: "#544AA1",
  blue200: "#b1c8d1",
  blue400: "#007abd",
  blue600: "#005580",
}
